import { render, staticRenderFns } from "./wavechart.vue?vue&type=template&id=472c4302&"
import script from "./wavechart.vue?vue&type=script&lang=js&"
export * from "./wavechart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports